import Element from "element-ui/lib/locale/lang/pt-br";
import VeeValidate from "vee-validate/dist/locale/pt_BR";

import pt from "./values/pt-br.json";

export default Object.assign(pt, {
  el: Element.el,
  veevalidate: VeeValidate,
});



// WEBPACK FOOTER //
// ./src/lang/pt-BR.js